import React from 'react';
import PropTypes from 'prop-types';
import { Container, List, StarRating } from '@pella/sash-framework';
import { CTA } from '../../../';

import ImageSlider from '../../../template/pdp-static/image-slider';

const ProductIntro = ({ data, rating, totalReviews, className, ...other }) => {
	if (!data) return null;

	return (
		<div
			className={`productIntro ${className || ''}`}
			{...other}
		>
			<Container>
				<div className='grid grid-cols-1 md:grid-cols-[315px_1fr] md:gap-x-5 xl:grid-cols-[600px_1fr] xl:gap-x-8'>
					<div className='row-start-2 mb-4 md:col-span-1 md:col-start-1 md:row-span-3 md:row-start-1 md:mb-0'>{(data.image?.[0] && <ImageSlider data={{ beauty_images: data.image }} />) || ''}</div>

					<div className='row-start-1 md:col-start-2 md:row-span-1'>
						{data.heading && (
							<h1
								className='mb-4'
								dangerouslySetInnerHTML={{ __html: data.heading }}
							/>
						)}

						<div className='mb-4 flex flex-wrap items-center xl:mb-12'>
							{data.material && (
								<div
									className='mr-2.5 rounded-full border border-black bg-primary px-4 py-1 text-xs font-semibold capitalize !leading-none md:mr-7 xl:mr-12 xl:text-lg'
									dangerouslySetInnerHTML={{ __html: data.material }}
								/>
							)}

							<StarRating
								rating={rating}
								totalReviews={totalReviews}
							/>
						</div>
					</div>

					<div className='md:col-2 row-start-3 md:row-start-2'>
						{data.description && (
							<div
								className='text-xs !leading-normal md:text-sm xl:text-22px'
								dangerouslySetInnerHTML={{ __html: data.description }}
							/>
						)}

						{data.cta?.[0] && (
							<List
								bullets='none'
								className='mt-6 space-y-2.5 xl:space-y-4'
							>
								{data.cta.map((cta, index) => (
									<li key={index}>
										<CTA data={cta} />
									</li>
								))}
							</List>
						)}
					</div>
				</div>
			</Container>
		</div>
	);
};

ProductIntro.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
	rating: PropTypes.number,
	totalReviews: PropTypes.number,
};

export default ProductIntro;
